import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
	button: {
		minWidth: "130px",
	},
	container: {
		borderRadius: "10px",
		overflow: "scroll",
	},
	br10: {
		borderRadius: "10px",
	},
	subtitle2Normal: {
		fontWeight: 400,
	},
	footer: {
		display: "flex",
		flexDirection: "row",
		width: "100%",
		justifyContent: "flex-end",
	},
	rowHeader: {
		position: "sticky",
		top: 212,
		backgroundColor: "white",
		height: "64px",
		paddingLeft: 12,
		zIndex: 2,
		paddingRight: 20,
		borderBottom: "1px solid #cddcdc",
	},
	rowHeaderFont: {
		fontWeight: 500,
	},
	headerCheckBox: {
		marginLeft: "-1px",
	},
	table: {
		"& tbody>.MuiTableRow-root": {
			borderBottom: `2px solid transparent`,
		},
	},
	normalButton: {
		textTransform: "none",
	},
	root: {
		"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
			borderWidth: "1px",
		},
	},
	selectField: {
		borderRadius: "20px",
		height: "29px",
		fontSize: "16px",
		"& .MuiSelect-outlined.MuiSelect-outlined": {
			paddingTop: 0,
			paddingBottom: 0,
		},
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: "rgba(54, 123, 245, 0.4)",
			height: "29px",
			top: 0,
			paddingTop: 0,
			paddingBottom: 0,
			"& legend": {
				display: "none",
			},
		},
		"& .MuiSelect-select:focus ": {
			backgroundColor: "unset",
		},
	},
	selectFieldQuest: {
		maxWidth: "145px",
	},
	selectFieldTask: {
		maxWidth: "160px",
	},
	filterColumn: {
		minWidth: "100px",
	},
	ul: {
		listStyle: "none",
		margin: 0,
		display: "flex",
		alignItems: "center",
		justifyContent: "space-evenly",
		width: "40%",
		minWidth: theme.breakpoints.values.sm,
	},
	pageInput: {
		width: "65px",
	},
	textInput: {
		fontSize: "0.875rem",
	},
	smallItem: {
		maxWidth: "100px",
	},
	cellRightAlignment: {
		textAlign: "right",
	},
	fw400: {
		fontWeight: 400,
	},
	fw700: {
		fontWeight: 700,
	},
	assignedToMeChip: {
		border: "1px solid rgba(54, 123, 245, 0.4)",
		fontSize: 16,
		height: 29,
		padding: "2px 4px",
		"&.MuiChip-clickable.MuiChip-outlined:hover, .MuiChip-clickable.MuiChip-outlined:focus": {
			backgroundColor: "transparent",
		},
	},
	thText: {
		cursor: "pointer",
		overflow: "hidden",
	},
	checkLabel: {
		width: "12px",
		color: "#357af5",
	},
	showMoreButton: {
		textTransform: "none",
		"&.MuiButton-root:hover ": {
			boxShadow: "none",
		},
	},
	flexRow: {
		display: "flex",
		alignItems: "center",
		justifyContent: "inherit",
		gap: "5px",
	},
}));
